module.exports = __webpack_public_path__ + "static/media/4.98b2d236.jpg";